import(/* webpackMode: "eager" */ "/workspace/frameworkassure/src/app/(auth)/login/page.tsx");
